import ApiBase from './api-base'
export default class workingSites extends ApiBase {
  constructor(store) {
    const path = 'admin/working-sites'
    super(path, store)
  }
}
